import { TournamentLinkBadge } from '@features/tournament/ui/components/TournamentSubHeader/badges/TournamentLinkBadge';

type Props = {
  tournament?: {
    tournamentId: string;
    rulesUrl?: string | null;
  };
};

export function TournamentRulesBadge({ tournament }: Props) {
  if (!tournament || !tournament.rulesUrl) return null;

  return <TournamentLinkBadge href={tournament?.rulesUrl}>Положение о турнире</TournamentLinkBadge>;
}
